import {environment} from './environments/environment';

export class AppConfigService2 {

  //  Os valores contidos aqui são sobrescritos pelos do app-config.js

  public verificaPermissoesFront;
  public sessaoTimeOut;   // Valor em minutos para a sessão de usuário expirar.
  public service;
  public application;
  public applicationName;
  public applicationVersion;
  public protocol;
  public region;
  public domain;
  public sitekey;
  public iuguTestMode;
  public habilitarRecaptcha;
}

